import React, { useEffect, useState } from 'react';
import { Button, Icon, Snackbar, Tab, Tabs, Tooltip } from '@mui/material';

import ProgressBar from '../../controls/ProgressBar';
import ErrorMessage from '../../controls/ErrorMessage';
import { Task } from '../../../models/portfolio/task';

import DialogTaskAdd from '../../controls/dialogs/DialogTaskAdd';

import { contentService } from '../../../services/content.service';
import { portfolioService } from '../../../services/portfolio.service';
import OverzichtTasks from './OverzichtTasks';
import { eventBus } from '../../../services/event-emitter.service';


interface TaskSwimlanesProps {
  portfolioId?: string;
  status?: string;
  mijnOrganisatieId?: string;
  organizations?: any[];
  refreshKey?: number;
  readOnly?: boolean;
}

const TaskSwimlanes: React.FC<TaskSwimlanesProps> = ({ 
  portfolioId,
  status,
  mijnOrganisatieId,
  organizations,
  refreshKey,
  readOnly = false,
}) => {

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const [snackbarMessage, setSnackbarMessage] = useState<string | null>(null);
  const [open, setOpenDialogs] = useState({
    task: false,
    taskShow: false,
    timeline: false,
    replies: false,
    snackbar: false
  });

  const [tabValue, setTabValue] = useState(0);
  const statusTabs = contentService.getTaskStatusses();

  // Handlers to open/close each dialog
  const openDialog = (dialog: keyof typeof open) => {
    // setSelectedId(id);
    setOpenDialogs((prev) => ({ ...prev, [dialog]: true }));
  };

  const closeDialog = (dialog: keyof typeof open) => {
    setOpenDialogs((prev) => ({ ...prev, [dialog]: false }));
  };

  useEffect(() => {
    eventBus.on('openDialog', triggerOpenDialog);

    // Cleanup
    return () => {
      eventBus.off('openDialog', triggerOpenDialog);
    };
  }, []);

  const triggerOpenDialog = (dialog: string) => {
    if (readOnly && dialog === 'task') {
      return;
    }

    if (dialog) {
      openDialog(dialog as keyof typeof open);
    }
  };
  
  const onClickAddTask = async () => {
    if (readOnly) {
      return;
    }
    openDialog('task');
  };

  const handleSubmitTask = async (task: Task) => {
    if (readOnly) {
      return;
    }

    try {
      setLoading(true);

      if (task) {

        let response;
        if (task.id) {
          response = await portfolioService.putTask(task);
        }
        else {
          response = await portfolioService.postTask(task);
        }
        
        if (response) { // response.ok
          // refreshTasks();
          setTimeout(() => {
            eventBus.emit('reloadTasks');

            setLoading(false);
            setSnackbarMessage('Actie succesvol opgeslagen');
            openDialog('snackbar');
          }, 2000);
        }
        else {
          setLoading(false);
        }
      } 
      else {
        console.error('Geen task om toe te voegen');
      }
      
    }
    catch (error) {
      setLoading(false);
      console.error('Error updating task:', error);
      setError('Er is een fout opgetreden');
    }
  };
  
  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={open.snackbar}
        autoHideDuration={2000}
        onClose={() => closeDialog('snackbar')}
        message={snackbarMessage ? snackbarMessage : 'Er is een fout opgetreden'}
        key={'topcenter'}
      />

      <div className="component-header">
        <h4>
          <Icon>assignment</Icon> Acties 
          {/* ({totalCount}) */}
        </h4>
        {!readOnly && (
          <div className="btn-group">
            <Tooltip title="Nieuwe actie toevoegen" placement="right" arrow>
              <Button variant="text" color="secondary" 
                onClick={() => onClickAddTask() }
              >
                <Icon>add</Icon>
                Actie
              </Button>
            </Tooltip>
          </div>
        )}
      </div>

      <Tabs
        value={tabValue}
        onChange={(e, newValue) => setTabValue(newValue)}
        aria-label="status tabs"
        TabIndicatorProps={{ className: `indicator-${tabValue}` }}
      >
        {statusTabs.map((tab, index) => (
          <Tab
            key={tab.value}
            label={tab.label}
            icon={<Icon className={`icon-cirle ${tab.value}`}>{tab.icon}</Icon>}
            iconPosition="start"
            className={tab.value}
          />
        ))}
      </Tabs>

      {statusTabs.map((tab, index) => (
        tabValue === index && (
          <div key={tab.value}>
            {tabValue === index && portfolioId && mijnOrganisatieId && organizations && (
              <OverzichtTasks
                portfolioId={portfolioId} 
                status={statusTabs[tabValue].value}
                organizations={organizations} 
                mijnOrganisatieId={mijnOrganisatieId}
                readOnly={readOnly}
              />
            )}
          </div>
        )
      ))}

      <DialogTaskAdd
        open={open.task}
        portfolioId={portfolioId}
        organizations={organizations}
        onClose={ () => closeDialog('task') }
        onSubmit={handleSubmitTask}
      />

      { loading && (
        <ProgressBar />
      )}

      { error && (
        <ErrorMessage message={error} />
      )}
    </>
  );
};

export default TaskSwimlanes;
